import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchProjectmeldingen'
import type { ProjectmeldingenSearch } from '../types/ProjectmeldingenSearch'

export { useProjectmeldingenSearchStore }

const useProjectmeldingenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<ProjectmeldingenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
